// test2022
(2022 && 0);
